<div fxLayout="column" style="height:100%">
    <div fxLayoutAlign="center center"><h2>{{reportHeader}}</h2></div>
    <div fxLayoutAlign="end center" class="new-report-nav">
        <button mat-button [routerLink]="['/default']" class="navigation-button navigation-button-proceed">New Quotation</button>
    </div>
    <div fxFlex>
        <iframe [src]="trustedURL" fxFlex></iframe>
        <!--<iframe [src]="https://docs.google.com/viewer?url=trustedURL&embedded=true" fxFlex></iframe>-->
        <!--
        <iframe fxFlex>
            <object fxFlex>
                <embed [src]="trustedURL" fxFlex />
            </object>
        </iframe>
        -->
    </div>
</div>